/**
 * Keeps permission-group wire roles aligned with the localized labels used when
 * roles are rendered as standalone UI fields.
 */
import type { PermissionGroupDto } from 'src/store/generated/leela-api-generated';

export type GroupRole = PermissionGroupDto['role'];

export const GroupRoleLabelKeys: Record<GroupRole, string> = {
  campaignLead: 'create_group_role_campaign_lead',
  campaignManager: 'create_group_role_campaign_manager',
  analyst: 'create_group_role_analyst',
  agencyOperator: 'create_group_role_agency_operator',
  agencyViewer: 'create_group_role_agency_viewer',
};

const EXTERNAL_GROUP_ROLES: ReadonlySet<GroupRole> = new Set<GroupRole>([
  'agencyOperator',
  'agencyViewer',
]);

export function isExternalGroupRole (role: GroupRole): boolean {
  return EXTERNAL_GROUP_ROLES.has(role);
}
